/*
 * エディット検索用コンポーネント
 */
<template>
<div class="name-search" >
	<div class="name" v-if="disp_title">
		{{r_title}}
	</div>
	<el-form :model="m_ruleForm" :rules="m_validation" ref="valid_target">
		<el-form-item prop="text">
			<c-inputedit 
				class="name-input" 
				:r_type="r_validattype" 
				v-model="m_ruleForm.text" 
				:r_input_class="r_input_class"
				:r_placeholder="place_holder" 
				:r_max_length="max_length"
				:r_max_fra_length="max_fra_length"
				:r_disabled="r_disabled"
				@blur="onBlur"
				@input="onChange"></c-inputedit>
		</el-form-item>
		<el-form-item class="radio" v-if="!r_is_radio_hide" prop="search_action">
			<el-radio-group v-model="m_ruleForm.search_action" @change="onRadio" :class="'radio-group-type-inherit'">
				<el-radio v-for='(info, index) in m_arrActionRadioList' :key="'radio-' + index" :label='info.value'>
					{{info.label}}
				</el-radio>
			</el-radio-group>
		</el-form-item>
	</el-form >
</div>
</template>
<script>
const NUMBER = "number"; // 整数
const DECIMAL = "decimal"; // 小数
const TEXT = "text"; // テキスト
const PASSWORD = "password"; //パスワード
const PASSWORD2 = "password2"; //パスワード
const HALF_WIDTH = "half-width"; // 半角英数字のみ
const HALF_WIDTH_MARK = "half-width-mark"; // 半角英数字記号のみ
const TELEPHONE = "telephone"; // 電話番号
const READ_ONLY = "read-only"; // リードのみテキスト
const HIRAGANA = "hiragana";// ひらがな
	 export default {
		mixins: [
			require('js/common/validate/common.mixin.vue'),
			require('js/common/validate/edit.mixin.vue'),
		],
		props:{
			'r_messages':{},
			'r_title':String,
			'r_is_radio_hide':{
				type:Boolean,
				default: false
			},
			'r_disabled':{
				type:Boolean,
				default: false
			},
			'r_validattype':{
				type:String,
				default: "text"
			},
			'r_placeholder': {
				type:String,
				default: ""
			},
			'r_max_length':{
				type:[Number,String],
				default:110
			},
			'r_code_max': {
				type:[Number,String],
				default: 999999
			},
			'r_code_min': {
				type:[Number,String],
				default: 1
			},
			'r_validator':null,//!< validate 処理を変更したい場合に指定する。指定がなければデフォルトチェックが有効になる
			'r_input_class':"",
			'r_action_radio_list': {
				default: () => []
			}
		},
		data: function (){
			var target = this;
			return{
				m_ruleForm: {
					text: '',
					search_action: this.r_is_radio_hide?0:1,
				},
				m_validation: {
					// text: [
					// 	{
					// 		validator: (rule, value, callback) => {
					// 			var errMessage = "";
					// 			var fnValidate = (target.r_validator)?target.r_validator:target.validateType;
					// 			var type = [target.CHKTYPE_ALPHANUM];
					// 			switch ( target.r_validattype ) {
					// 				case NUMBER: // 正数
					// 					type = [target.CHKTYPE_NUMBER,target.CHKTYPE_CODE];
					// 					break;
					// 				case DECIMAL: // 小数
					// 					type = [target.CHKTYPE_DECLEN,target.CHKTYPE_CODE];
					// 					break;
					// 				case TELEPHONE:// 電話番号
					// 					type = [target.CHKTYPE_TEL];
					// 					break;
					// 				case HIRAGANA:// ひらがな
					// 					type = [target.CHKTYPE_KANA];
					// 					break;
					// 				case TEXT: // テキスト
					// 					type = [target.CHKTYPE_TEXTLEN,target.CHKTYPE_TXTLEN];
					// 					break;
					// 				case "":
					// 				case PASSWORD: //パスワード
					// 				case HALF_WIDTH: // 半角テキストのみ
					// 				default:
					// 					type = [target.CHKTYPE_ALPHANUM,target.CHKTYPE_TXTLEN];
					// 					break;
					// 				case HALF_WIDTH_MARK: // 半角英数字記号のみ
					// 				case PASSWORD2: //パスワード
					// 					type = [target.CHKTYPE_HALF,target.CHKTYPE_TXTLEN];
					// 					break;
					// 			}

					// 			errMessage = fnValidate(type,
					// 									value,
					// 									target.r_code_max,
					// 									target.r_code_min,
					// 									Number(target.r_max_length));

								
					// 			if ( errMessage.length > 0 ) {
					// 				callback(new Error(errMessage));
					// 			} else {
					// 				callback();
					// 			}
					// 		},
					// 		trigger: ''
					// 	},
					// ],
					// search_action: [
					// ],
				},
				m_arrActionRadioList: []
			}
		},
		created: function () {
			this.$on('event_clear', this.setClear);
			if(!this.r_is_radio_hide){
				if(this.r_action_radio_list.length){
					// 親から渡されたリストを使用する
					this.m_arrActionRadioList = this.r_action_radio_list;
				}else{
					// デフォルトの選択肢を追加する
					this.m_arrActionRadioList = [
						{
							value: 1,
							label: this.r_messages.search_all
						},
						{
							value: 2,
							label: this.r_messages.search_or
						}
					];
				}
			}
			
		},
		computed: {
			disp_title:function(){
				if(this.r_title && this.r_title.length > 0) return true;
				return false;
			},
			place_holder: function(){
				if(this.r_placeholder){
					return this.r_placeholder;
				}
				if(this.r_messages){
					return this.r_messages.placeholder_free_word;
				}
				return "";
			},
			valid_target: function(){
				return this.$refs.valid_target;
			},
			max_length: function(){
				switch ( this.r_validattype ) {
					case NUMBER: // 正数
					case DECIMAL: // 小数
						var str = this.r_code_max.toString().split('.');
						if ( str[0] ) {
							return str[0].length;
						}
						break;
				}
				return Number(this.r_max_length);
			},
			max_fra_length: function(){
				switch ( this.r_validattype ) {
					case NUMBER: // 正数
					case DECIMAL: // 小数
						var str = this.r_code_max.toString().split('.');
						if ( str[1] ) {
							return str[1].length;
						}
						break;
				}
				return 0;
			},
		},
		methods: {
			setClear: function () {
				this.valid_target.resetFields();
				this.m_ruleForm.text = "";
				this.m_ruleForm.search_action = this.r_is_radio_hide?0:1;
			},
			setClearAndChange: function () {
				this.setClear();
				this.onChange("");
			},
			/**
			 * 明示的な値のセット
			 */
			setParam: function(text, searchAction){
				this.m_ruleForm.text = text;
				this.m_ruleForm.search_action = searchAction;
			},
			getParam: function( ){
				return this.m_ruleForm;
			},
			onBlur: function(e) {
				this.$emit('blur', e);
			},
			onChange:function(val){
				console.log("onChange :");
				console.log(val);

				this.$emit("input",this.m_ruleForm.text);
				this.$emit("change");
			},
			onRadio:function(){
				this.$emit("change");
			}
		},
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/search/editSearchText.vue